import { BaseApi } from './baseApi';

export class FeedbackApi extends BaseApi {
    submit(workspaceId, websiteId, payload) {
        return this.post(`/workspaces/${workspaceId}/websites/${websiteId}/feedback`, payload);
    }
}

export default ((options) => new FeedbackApi(options))();
